import React from "react";
import { XIcon } from "staysure-component-library";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import RichText from "@/components/atoms/rich-text/rich-text";
import { PolicyDocumentModalContentTypes } from "@/types/policy-document-types";

import Styles from "../policy-document-section.module.css";

function PolicyDocumentModalContent(
  props: Readonly<PolicyDocumentModalContentTypes>
) {
  const {
    modalTitle,
    modalContent,
    modalContentUnauthorized,
    modalButtonOne,
    setIsOpen,
  } = props;

  return (
    <div>
      <button
        id="policy-document-modal-content-close-button"
        type="button"
        className=" absolute right-4 top-4"
        onClick={() => {
          setIsOpen(false);
        }}
        aria-label="close modal"
      >
        <XIcon stroke="#306582 " />
      </button>
      <div
        className=" p-spacing-l md:p-spacing-xxxl flex-col "
        data-testid="policy-document-modal-content-testid"
      >
        <div className="">
          <div className="mb-spacing-xs md:mb-spacing-s">
            <h1 className=" font-header-font text-[24px] md:text-[31px] leading-[29.9px] md:leading-[34.10px] text-text-title">
              {modalTitle || "We are unable to proceed with your request"}
            </h1>
          </div>
          <div className=" mb-spacing-l">
            <p className=" font-body-font font-normal text-2xs leading-[27px] ">
              {modalContent && (
                <RichText
                  className={`${Styles.richtext}`}
                  richText={modalContent ?? ""}
                />
              )}{" "}
              {modalContentUnauthorized && (
                <RichText richText={modalContentUnauthorized ?? ""} />
              )}
              {/* { 
                "Sorry, but we are currently unable to access your documents. Please check you have the correct details. If you are still having trouble, call us on XXXX XXX XXXX."} */}
            </p>
          </div>
        </div>
        <div className=" flex flex-col md:flex-row justify-center gap-2">
          <LabelButtonWrapper
            data-testid="policy-document-modal-content-confirm-button"
            id="policy-document-modal-content-primary-button"
            label={modalButtonOne}
            hierarchy="secondary"
            type="button"
            onClick={() => {
              setIsOpen(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default PolicyDocumentModalContent;
